<template>
    <div class="subscription">
        <div class="container mx-auto">
            <echart class="w-full" :options="graphOptions"></echart>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        echart: () => import("../../components/charts/BarChart")
    },
    props: {
        company_id: 0
    },
    data() {
        return {
            graphOptions : {
                color: [],
                legend: {
                    data: []
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: []
            }
        }
    },

    methods: {
        async getOrders () {
            const {data} = await this.$axios.get(`/company/${this.company_id}/orders`);
            this.graphOptions.legend = {
                data: data.legends
            };
            this.graphOptions.xAxis = {
                type : 'category',
                data: data.period
            };
            this.graphOptions.color = data.colors;
            const series = Object.entries(data.data);
            this.graphOptions.series = series.map(serie => ({data: serie[1], name: serie[0], type: 'bar', stack: 'orders', label: {normal: {show: true}}}));

            this.graphOptions.legend.data.push("Total");
            this.graphOptions.color.push("#009ACD");

            let total = Object.values(data.data);
            total = Object.values(data.data).reduce((r, acc)=>{
                acc.forEach((value, i) => {
                    r[i] = (r[i] || 0) + value.value;
                });
                return r;
            }, []);
            this.graphOptions.series.push({
                name: 'Total',
                data: total,
                type: 'line',
                label: {
                    normal: {
                        show: true
                    }
                },
            })
        }
    },

    created() {
        this.getOrders();
    },
}
</script>

<style scoped>

</style>
